/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';
import { City } from '@app/settings/cities/cities.model';
import { Contact } from '@app/shared/components/contact/contact.model';
import { Website } from '@app/settings/websites/website.model';

export class Company extends Model {
  id: number;
  name: string;
  city_id: number;
  city?: City;
  logo: string;
  new_logo?: string;
  color: string;
  contacts: Array<Contact>;
  bank_accounts?: Array<BankAccount>;
  //  properties: Array<Property>;
  websites?: Array<Website>;
  address: string;
  abbreviation: string;
  registration_number: string;
  tax_number: string;
  vat_number: string;
  iata_tids_number: string;
  active: boolean;

  vat_percent: number;
  proforma_prefix: string;
  invoice_digits_count: number;

  get shortName(): string {
    return this.abbreviation;
  }

  deserialize(input: any): this {
    super.deserialize(input);

    // WARNING in Circular dependency detected
    // if (input.websites) {
    //   this.websites = input.websites.map((website: Website) => new Website().deserialize(website));
    // }

    if (input.bank_accounts) {
      this.bank_accounts = input.bank_accounts.map((bankAccount: BankAccount) =>
        new BankAccount().deserialize(bankAccount)
      );
    }

    if (input.contacts) {
      this.contacts = input.contacts.map((contact: Contact) => new Contact().deserialize(contact));
    }

    if (input.city) {
      this.city = new City().deserialize(input.city);
    }

    return this;
  }

  /**
   *  Връща контрастен цвят. Използва се за да може да се чете текста.
   */
  get invertColor(): string {
    if (this.color) {
      return this.invColor(this.color);
    }
    return null;
  }

  /**
   *  Връща контрастен цвят.
   * https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
   * @param hex color
   * @param bw Boolean дали да го обръща към бяло или черно
   */
  private invColor(hex: string, bw: boolean = true): string {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    let r: any = parseInt(hex.slice(0, 2), 16),
      g: any = parseInt(hex.slice(2, 4), 16),
      b: any = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // http://stackoverflow.com/a/3943023/112731
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
  }

  private padZero(str: any, len: any = 2) {
    const zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }
}
